/* 🤖 this file was generated by svg-to-ts */
export const siriusTargetLightPictogram: {
  name: 'target_light_pictogram';
  data: string;
} = {
  name: 'target_light_pictogram',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" style="display: block;"><path d="M41.262 15.755a19.138 19.138 0 1 1-4.558-6.05l4.5-4.5a1.125 1.125 0 0 1 1.591 1.59L31.16 18.432l-6.365 6.364a1.125 1.125 0 0 1-1.59-1.59l5.51-5.511a7.874 7.874 0 1 0 3.147 5.856 1.125 1.125 0 1 1 2.247-.128 10.126 10.126 0 1 1-3.79-7.332l4.789-4.789a16.85 16.85 0 1 0 4.123 5.423 1.124 1.124 0 1 1 2.03-.97Z" fill="currentColor"/></svg>`
};
